import { render, staticRenderFns } from "./changeMpinComponent.vue?vue&type=template&id=5518ad54&"
import script from "./changeMpinComponent.vue?vue&type=script&lang=js&"
export * from "./changeMpinComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports